import axios from 'axios';

const http = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        //'version': process.env.REACT_APP_VERSION
        // 'version': '1.0.0',
        //Token desarrollo
        //'x-access-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZEFjY2Vzb3NBcGkiOiIyIiwidXN1YXJpbyI6IlNpdHVMb2phIiwidGlwb0FjY2VzbyI6MiwicmVzdHJpY2Npb24iOjEsImxpc3RhSXAiOnsibW9kdWxvcyI6W3siaWQiOjF9XSwiaXBQZXJtaXRpZGEiOltdLCJpcE5vUGVybWl0aWRhIjpbeyJpcCI6Ijo6MSJ9XX0sImlhdCI6MTY1NTE1NTg1MH0.fj_Nw77nppmkJqBLpf3n2fg0bTQt34JtZ2i76Ig175U',
        //Token producción
        'x-access-token' : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoiOTQ4YjdlOGIwNWFhZTMwOTUwZTUyNGVkMTUzMDg1MWRjM2NiOTZiYjk1OGVkZDA0MTU4ZGY3MDI5MTdkMWZjZTA5MGExMjFkN2YwMTM4N2QxYTAwODQ0NjdlZjg4MjEwOGQ4N2YzZGM1MzJhNTFkZThiMzc0YjkyMzU2YTFhMDFiN2Y0NGViMjZlYzBkMjQ5NjhmNmYzNzYyZjc4YjM0OTc0YmQyMWE0NjJlYzE3NTQ0ODJiNGE2YzI5MzgwNzc2YTVjMDBiMmU3ZTJmMzA0YTgxZDNmY2QwZWQxZjE4Mjk4ZDAzM2EwYzJjY2VlNDhlMTAyYjVkYmEzZDI0NTg5NmQwMTViZWJkMTRkNDhkNmMwNjdhNzQxZTZiYzRmNTc0MWZmZTM5OTJlMTUxNDkyYTY5MGIwOGM5ZTY0ODY1OWQwMTUyMTg0MjIwMmYxYzBhOTIxYzQ2MDI4YWE0ZDhmZTYzYzM0ZWVlODJjMjM5YjNmZTJiMzNkMDExNTE1YjdjYmYzZWRkNWQ0YjI2OWE0MjUxNzU3NDU3MjM1NzgxYTc4NDNhNmU5NjVkMjIyMjcxZmZjMGRiZTEwNGVkZTg4MWJhYmIyNGE2YTA4NmFmNTAzZTVhYjU0ZTFmOTM3ODA2YzEzNjJkZTk5M2MzNDgxYjkzZDBkMzgxNTNjNmYwNmMyMzE5Y2EyZTk5OWY0ZDQyMTQ2NDVlZjczOTc1N2VlMmJkNjJkYzM2NDdmM2UxMzMyODEwOTU0YjZjZWRjOWUxYzgyNzY3MDgyZDI5YTYyODFiYjhkYjY2YjVmZGY5MzU1MjRkMDVmZTBjNDM5ZGY2MGM4NmQ4YmE2MGExMGIzNTc1YzU2MGFlYTg0N2YyMzVhNmRiYzUxMTljN2IzNTQ3IiwiaWF0IjoxNjYwNzkwOTQwfQ.2kJkxp20JFNpiszibwUyV9o8Dv1SZQqQqXq4L4_yTbk',
        'authorization': 'SVROR1RsbGViRFY2WTNraFUwdHdZMUpOMg==',
    }
});

export default class HttpService {
    static post(url, params, config = null) {
        return http.post(url, params, config);
    }

    static get(url, config = null) {
        return http.get(url, config);
    }
}
